export default __webpack_public_path__ + "static/media/home-hero.fd677bc5.png";